import type { ItemPreviewV1 } from '@seeqdev/api/model/ItemPreviewV1';

export enum WORKBOOK_DISPLAY {
  EDIT = 'WORKBOOK_DISPLAY.EDIT',
  VIEW = 'WORKBOOK_DISPLAY.VIEW',
  PRESENT = 'WORKBOOK_DISPLAY.PRESENT',
}

export const DEFAULT_WORKBOOK_STATE = { stores: {} };

/**
 * The Flux store for workbook state
 */
export const LOAD_STATUS = {
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  ERROR: 'ERROR',
  NOT_LOADED: 'NOT_LOADED',
} as const;

export type WorkbookItemPreview = ItemPreviewV1 & {
  tabHash?: string;
  translationKey?: string;
};

/**
 * Metadata describing a locked workbook. Stored on the workbook store and serialized into the
 * workbook's `lockedMetadata` property.
 */
export interface LockedMetadataIF {
  lockedAt: number;
  lockedById: string;
  lockedByUsername: string;
}
